const STORAGE_KEY = 'growtype_chat_videocall_debug';
const QUERY_PARAM = 'videocall_debug';
const VIDEOCALL_DEBUG_ENABLED = false;

function storeOverride(enabled) {
    try {
        window.localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0');
    } catch (error) {}
}

function clearStoredOverride() {
    try {
        window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
}

function resolveInitialState() {
    return { enabled: VIDEOCALL_DEBUG_ENABLED, source: 'build' };
}

function describeError(error) {
    if (!error) return null;
    return {
        name: error.name || null,
        message: error.message || String(error),
    };
}

export function createVideocallDebugLogger(options = {}) {
    const build = options.build || 'unknown';
    const output = options.output || console.log.bind(console);
    const initial = resolveInitialState();
    let enabled = initial.enabled;
    let source = initial.source;
    let sequence = 0;
    let removeLifecycleListeners = function () {};

    function log(...args) {
        if (!enabled) return;
        sequence += 1;
        output(
            `[growtype-chat][videocall][build:${build}][${sequence}][${new Date().toISOString()}]`,
            ...args
        );
    }

    function setEnabled(nextEnabled, nextSource = 'console') {
        enabled = Boolean(nextEnabled);
        source = nextSource;
        storeOverride(enabled);
        if (enabled) log('!!! VIDEO CALL DEBUG LOGGING ENABLED !!!', status());
        return status();
    }

    function status() {
        return {
            enabled: enabled,
            source: source,
            build: build,
            storageKey: STORAGE_KEY,
            queryParameter: QUERY_PARAM,
        };
    }

    function observeBrowserLifecycle(getState = function () { return {}; }) {
        removeLifecycleListeners();
        const listeners = [];
        const add = function(target, eventName, handler) {
            target.addEventListener(eventName, handler);
            listeners.push(function() { target.removeEventListener(eventName, handler); });
        };
        const snapshot = function(eventName, details = {}) {
            let state = {};
            try { state = getState() || {}; }
            catch (error) { state = { snapshotError: describeError(error) }; }
            log(`Browser lifecycle: ${eventName}`, Object.assign({}, details, { state: state }));
        };

        add(window, 'pageshow', function(event) { snapshot('pageshow', { persisted: Boolean(event.persisted) }); });
        add(window, 'pagehide', function(event) { snapshot('pagehide', { persisted: Boolean(event.persisted) }); });
        add(window, 'online', function() { snapshot('online'); });
        add(window, 'offline', function() { snapshot('offline'); });
        add(window, 'orientationchange', function() { snapshot('orientationchange', { orientation: window.orientation }); });
        add(window, 'error', function(event) {
            snapshot('window error', {
                message: event.message || null,
                filename: event.filename || null,
                line: event.lineno || null,
                column: event.colno || null,
                error: describeError(event.error),
            });
        });
        add(window, 'unhandledrejection', function(event) {
            snapshot('unhandled promise rejection', { reason: describeError(event.reason) });
        });
        add(document, 'visibilitychange', function() {
            snapshot('visibilitychange', { visibilityState: document.visibilityState, hidden: document.hidden });
        });

        if (navigator.mediaDevices && typeof navigator.mediaDevices.addEventListener === 'function') {
            add(navigator.mediaDevices, 'devicechange', function() { snapshot('media device change'); });
        }

        removeLifecycleListeners = function() {
            listeners.splice(0).forEach(function(remove) { remove(); });
            removeLifecycleListeners = function () {};
        };
        snapshot('observers attached', {
            path: window.location.pathname,
            userAgent: navigator.userAgent,
        });
        return removeLifecycleListeners;
    }

    const api = {
        enable: function() { return setEnabled(true); },
        disable: function() { return setEnabled(false); },
        clearOverride: function() {
            clearStoredOverride();
            const refreshed = resolveInitialState();
            enabled = refreshed.enabled;
            source = refreshed.source;
            return status();
        },
        status: status,
    };
    window.growtypeVideocallDebug = api;

    if (enabled) log('!!! VIDEO CALL DEBUG LOGGING ENABLED !!!', status());

    return {
        log: log,
        status: status,
        observeBrowserLifecycle: observeBrowserLifecycle,
        cleanup: function() { removeLifecycleListeners(); },
    };
}
